<!--

/varejo/recebiveis

-->

<script>
import axios from 'axios'
import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import FilterList from '../components/filter-list'
import Filtro from "../consultas/filtro";
import { objectToCsv, downloadCsvReport } from '../shared/csvReport'
import { apiORDSpost, apiDownload2 } from '../shared/api-functions'

export default {
  data() {
    return {
      filter: '',
      metadata: this.$store.getters.getEntities.metadata,
      moreActionsBarList: [],
      monthFilter: {},
      statusQuery: '',
      filterList: [],
      paramFilterList: {},
      showForm: false,
      codfin: '',
      url: '',
      textQuery: '',
      dados: [],
      resumo: [],
      totais: null,

      //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
      showfiltro: false,
      paramsFiltro: {
        periodo: {
          label: "Data de Vencimento",
          varios: false,
          data_inicio: null,
          data_termino: null,
        },
        filtros: [
          {
            nome: "formapagamento",
            label: null,
            url: null,
            varios: false,
            values: []
          },
          {
            nome: "filial",
            label: null,
            url: null,
            varios: false,
            values: []
          },
        ],
      },
      filtro: {
        periodos: [{ data_inicio: null, data_termino: null }],
      },

    }
  },

  computed: {

  },

  watch: {
    finTotal: function () {
      //AQUI MONTA O OBJETO PARA A LISTA DE FILTROS DO COMPONENTE filter-list BASEADO NO OBJETO DE TOTAIS CARREGADO DO SERVIDOR

      this.filterList = []
      let total = {}

      let tot = 0
      let qt = 0
      for (let i = 0; i < this.finTotal.length; i++) {
        tot = tot + this.finTotal[i].total
        qt = qt + this.finTotal[i].qt
      }

      for (let i = 0; i < this.finTotal.length; i++) {
        total = {}
        total.label = ''
        total.total = this.finTotal[i].total
        total.qt = this.finTotal[i].qt
        total.status = this.finTotal[i].status
        //calcula o % em relacao ao total
        if (tot > 0) {
          total.perc = total.total / tot * 100
        }
        if (total.status == 'VENCIDOS') {
          total.label = 'Vencidos'
        } else if (total.status == 'ABERTOS') {
          total.label = 'A Receber'
        } else if (total.status == 'RECEBIDOS') {
          total.label = 'Recebidos'
        }
        this.filterList.push({ ...total })
      }
      total = {}
      total.status = 'TOTAL'
      total.label = 'Total'
      total.total = tot
      total.qt = qt
      this.filterList.push({ ...total })
      this.paramFilterList = { total: this.filterList, selectedStatus: '' }
    },
  },
  methods: {

    handleShowFiltro() {
      this.showfiltro = true;
    },

    filtroChange(filtro) {
      this.showfiltro = false;

      this.filtro = filtro;
      this.paramsFiltro.filtros[0].values = this.filtro.formapagamento
      this.paramsFiltro.filtros[1].values = this.filtro.filial

      this.loadData(false);
    },

    closeForm() {
      this.showForm = false
      this.loadData(false)
    },

    loadData(excel) {
      let url = "consulta/vendas/varejorecebiveis";

      this.filtro.excel = excel;

      if (excel)
        apiDownload2(this, url, this.filtro, "post")
      else {
        this.mounting = true
        let self = this
        apiORDSpost(this.$store, url, this.filtro, "post").then((data) => {
          self.dados = data.items
          self.resumo = data.resumo
          self.totais = data.totais
          self.mounting = false
        })
      }
    },

    textST(aberto, baixado, cancelado) {
      if (aberto === 'S') {
        return 'A Receber'
      } else if (baixado === 'S') {
        return 'Recebido'
      } else if (cancelado === 'S') {
        return 'Cancelado'
      }
    },


  },

  filters: {

  },

  components: {
    BarList, BarGrid, FilterList, Filtro
  },

  created() {
    this.filtro.periodos[0].data_inicio = this.$firstDay(this.$getDate())
    this.filtro.periodos[0].data_termino = this.$lastDay(this.$getDate())
    this.loadData(false)
  }

}

</script>

<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <bar-list :refresh-button="true" :filtro-mes="false" :new-button="false"
          single-entity="Valores a Receber Por Data de Crédito" plural-entity="Valores a Receber Por Data de Crédito"
          :hideSearch="true" :refreshButton="false">
        </bar-list>
      </div>
    </div>

    <filtro :showfiltro="showfiltro" :params="paramsFiltro" @change="filtroChange" @cancel="showfiltro = false"></filtro>

    <!-- <filter-list :params="paramFilterList" @select="handleFilterList"></filter-list> -->

    <div class="row mb-3 align-items-center">
      <div class="col-md-6 col-12">
        <v-button label="Filtro" :success="true" @click="handleShowFiltro"></v-button>
        <v-button title="Atualizar Grid" icon="fa-refresh" @click="loadData"></v-button>
        <v-button label="Excel" @click="loadData(true)"></v-button>
      </div>
    </div>

    <div class="default-container">
      <div class="row mb-2">
        <div class="col-12 lbl-title">
          Resumo De Valores a Receber Por Forma de Pagamento
        </div>
        <div class="col-12 mb-3">
          Dados exibidos somente de caixas fechados
        </div>
        <div class="col-auto" v-if="filtro.periodos.length">
          <label class="lbl-list">Data de Início</label>
          <span class="data-list">{{ filtro.periodos[0].data_inicio | formatData }}</span>
        </div>
        <div class="col-auto" v-if="filtro.periodos.length">
          <label class="lbl-list">Data de Término</label>
          <span class="data-list">{{ filtro.periodos[0].data_termino | formatData }}</span>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col-12 p-3" v-if="!resumo || resumo.length == 0">
          Nenhum movimento encontrado
        </div>
        <div class="col-md-8" v-else>
          <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
            <div style="overflow: auto">
              <table class="table table-bordered table-sm responsive w-100">
                <thead>
                  <tr>
                    <th colspan="1" class="text-center">
                      Forma de Pagamento
                    </th>
                    <th colspan="1" class="numerico size100">
                      Valor Original R$
                    </th>
                    <th colspan="1" class="numerico size100">
                      Valor Líquido R$
                    </th>
                    <th colspan="1" class="numerico size100">
                      Taxas R$
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in resumo" :key="index">
                    <td class="textual">{{ row.descricao }}</td>
                    <td class="numerico size100">{{ row.valor | formatValue(2) }}</td>
                    <td class="numerico size100">{{ row.valorliquido | formatValue(2) }}</td>
                    <td class="numerico size100">{{ row.taxas | formatValue(2) }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th class="text-right total">Total</th>
                    <th class="numerico size100 total"> {{ totais.total | formatValue(2) }} </th>
                    <th class="numerico size100 total"> {{ totais.totalliquido | formatValue(2) }} </th>
                    <th class="numerico size100 total"> {{ totais.totaltaxas | formatValue(2) }} </th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>



      <div class="row mb-2" v-if="dados && dados.length">
        <div class="col-12 lbl-title">
          Detalhes
        </div>
      </div>
      <div class="row mb-5" v-if="dados && dados.length">
        <div class="col-md-8">
          <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
            <div style="overflow: auto">
              <table class="table table-bordered table-sm responsive w-100">
                <thead>
                  <tr>
                    <th colspan="1" class="text-center">
                      Pedido
                    </th>
                    <th colspan="1" class="text-center">
                      Forma de Pagamento
                    </th>
                    <th colspan="1" class="text-center">
                      Data da Venda
                    </th>
                    <th colspan="1" class="text-center">
                      Data do Crédito
                    </th>
                    <th colspan="1" class="numerico size100">
                      Valor Original R$
                    </th>
                    <th colspan="1" class="numerico size100">
                      Valor Líquido R$
                    </th>
                    <th colspan="1" class="numerico size100">
                      Taxas R$
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in dados" :key="index">
                    <td class="textual">{{ row.npedido }}</td>
                    <td class="textual">{{ row.descricao }}</td>
                    <td class="textual">{{ row.data | formatData }}</td>
                    <td class="textual">{{ row.dtcredito | formatData }}</td>
                    <td class="numerico size100">{{ row.valor | formatValue(2) }}</td>
                    <td class="numerico size100">{{ row.valorliquido | formatValue(2) }}</td>
                    <td class="numerico size100">{{ row.taxas | formatValue(2) }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th colspan="4" class="text-right total">Total</th>
                    <th class="numerico size100 total"> {{ totais.total | formatValue(2) }} </th>
                    <th class="numerico size100 total"> {{ totais.totalliquido | formatValue(2) }} </th>
                    <th class="numerico size100 total"> {{ totais.totaltaxas | formatValue(2) }} </th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>


<style></style>






// WEBPACK FOOTER //
// src/forms-varejo/varejo-recebiveis-list.vue